import { useListStore } from '@/js/stores/listStore'
import type { BuyRequest, IRogue } from '@/js/services/RogueTypes'

export default async function moveAllSfl(rogue: IRogue) {
  const listStore = useListStore(rogue.pinia)
  const copy = JSON.parse(JSON.stringify(listStore.sfl.items)) as BuyRequest[]

  copy.forEach((item, i) => {
    listStore.addListItems(rogue, 'cart', [item], false, false)

    listStore.removeFromListItems(rogue, 'sfl', copy[i]._id!, false)
  })

  listStore.addMessage(rogue, {
    list : 'cart',
    text : 'All Save for Later products have been added to your cart.',
    type : 'multiAdd',
  })
}
